<template>
  <div>
    <div class="page-section">
      <div class="container">
        <div class="section-head">
          <div class="section-head-title">{{ title ? title : $t('components.popularQuestions.title') }}</div>
        </div>
        <div class="section-content">
          <div class="faq-list" itemscope itemtype="https://schema.org/FAQPage">
            <div v-for="(question, index) of questions.length > 0 ? questions : defaultQuestions" class="faq-item"
              :class="{ open: isFaqOpen(index) }" itemprop="mainEntity" itemscope itemtype="https://schema.org/Question">
              <div class="item-head">
                <div class="item-head-title" itemprop="name">{{ rt(question.question) }}</div>
                <button type="button" @click="toggleOpen(index)" class="item-head-icon cursor-pointer"
                  :aria-expanded="isFaqOpen(index)" :aria-label="$t('components.popularQuestions.toggleAnswer')"></button>
              </div>
              <div v-show="isFaqOpen(index)" :class="{ open: isFaqOpen(index) }" class="item-content"
                itemprop="acceptedAnswer" itemscope itemtype="https://schema.org/Answer">
                <div itemprop="text" v-html="rt(question.answer)"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, type PropType } from 'vue'

const { tm, rt } = useI18n()

type Question = {
  question: string
  answer: string
  isOpen?: boolean
}

const props = defineProps({
  title: {
    type: String,
    default: ''
  },
  questions: {
    type: Array as PropType<Question[]>,
    default: () => []
  }
})

const defaultQuestions = ref<Question[]>([])

const items = tm('components.popularQuestions.questions') as any[]
if (Array.isArray(items)) {
  defaultQuestions.value = items.map((q: any) => ({
    question: q.question,
    answer: q.answer
  }))
}

const openStates = ref<Record<number, boolean>>({});

const isFaqOpen = (index: number) => {
  return !!openStates.value[index];
};

const toggleOpen = (index: number) => {
  openStates.value[index] = !openStates.value[index];
};
</script>
